// @flow

import { store as CONFIG_STORE } from 'Config';

/**
 * selectFavoriteByArtId
 *
 * @param {number | string} artId
 * @returns Function
 */
export function selectFavoriteByArtId(artId: number | string): Function {
  return (state: Object): ?number => {
    const list = state[CONFIG_STORE.keys.favorites].data;

    const favoriteData = list[parseInt(artId, 10)];
    return (favoriteData && favoriteData.id) || null;
  };
}
